export default {
  getDeployedContractsPage () {
    return '/deployed-contracts'
  },
}